module.exports = __webpack_public_path__ + "img/ypo-logo.c34ba722.png";